import React from 'react';
import styles from './informationsPage.module.scss';
import phonePay from '../../../../../assets/images/payments_info/1-cutout.png';
import moneyArt from '../../../../../assets/images/payments_info/4-cutout.png';
import { ReactComponent as MetodsIcon } from '../../../../../assets/svg/icons/payment_metods.svg';
import { ReactComponent as MetodPPAy } from '../../../../../assets/svg/icons/logo_ppay.svg';
import { Button } from '@mui/material';
import { ChevronRight } from 'lucide-react';
import clsx from 'clsx';
import useWindowSize from 'utils/useWindowSize';
import { ROUTES } from 'routes/constants';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BENEFITS = [
  { key: 'eliminateCancellations', tone: 'gold' },
  { key: 'verifiedBookings', tone: 'purple' },
  { key: 'setRules', tone: 'green' },
  { key: 'accessEarnings', tone: 'blue' },
];

const InformationsPage = () => {
  const { t } = useTranslation();
  const { isMobile } = useWindowSize();
  const navigate = useNavigate();

  return (
    <div className={clsx(styles.container, { [styles.container_mobile]: isMobile })}>
      <div className={styles.copy}>
        <span className={styles.eyebrow}>{t('payments.informationsPage.eyebrow')}</span>
        <h1 className={styles.h1}>{t('payments.informationsPage.title')}</h1>
        <p className={styles.lead}>{t('payments.informationsPage.description')}</p>

        <div className={styles.benefits}>
          {BENEFITS.map((item) => (
            <article
              key={item.key}
              className={clsx(styles.benefit, styles[`benefit_${item.tone}`])}
            >
              <span className={styles.benefit_highlight}>
                {t(`payments.informationsPage.steps.${item.key}.highlight`)}
              </span>
              <span className={styles.benefit_rest}>
                {t(`payments.informationsPage.steps.${item.key}.rest`)}
              </span>
            </article>
          ))}
        </div>

        <Button
          className={styles.confirm_button}
          onClick={() => navigate(`${ROUTES.PAYMENTS}${ROUTES.STEPS}`)}
          variant="contained"
        >
          {t('payments.informationsPage.startNow')}
          <ChevronRight size={20} strokeWidth={2.6} />
        </Button>
        <p className={styles.reassure}>
          <strong>{t('payments.informationsPage.nothingChangesBold')}</strong>{' '}
          {t('payments.informationsPage.nothingChanges')}
        </p>
      </div>

      <div className={styles.visual}>
        <img className={styles.phone_back} src={phonePay} alt="" />
        <img className={styles.phone} src={phonePay} alt="" />
        <img className={styles.money} src={moneyArt} alt="" />

        <article className={clsx(styles.float_card, styles.card_proof)}>
          <span className={styles.proof_value}>{t('payments.informationsPage.proofValue')}</span>
          <span className={styles.proof_caption}>
            {t('payments.informationsPage.proofCaption')}
          </span>
        </article>

        <article className={clsx(styles.float_card, styles.card_rate)}>
          <span className={styles.rate}>
            {t('payments.informationsPage.commissionTable.rate')}
          </span>
          <span className={styles.rate_meta}>
            {t('payments.informationsPage.commissionTable.perTransaction')}
          </span>
          <div className={styles.icons_row}>
            <MetodsIcon height="18px" width="auto" />
            <MetodPPAy height="18px" width="auto" />
          </div>
        </article>
      </div>
    </div>
  );
};

export default InformationsPage;
